var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { OPEN_NEW_STAGE_MODAL } from "../../../constants";
import { ModalContext } from "../../../providers/ModalContextProvider";
function AddStage({ pipelineId, stagesLength = 0 }) {
    const { modalDispatch } = useContext(ModalContext);
    const openNewStageModal = () => __awaiter(this, void 0, void 0, function* () {
        modalDispatch({
            type: OPEN_NEW_STAGE_MODAL,
            payload: {
                targetPipelineId: pipelineId,
            },
        });
    });
    if (stagesLength === 0) {
        return (_jsx("div", { className: "wpqt-pipeline-height wpqt-flex wpqt-w-full wpqt-items-center wpqt-justify-center", children: _jsxs("div", { className: "wpqt-main-border wpqt-flex wpqt-cursor-pointer wpqt-flex-col wpqt-items-center wpqt-justify-start wpqt-gap-y-1 wpqt-p-3 hover:wpqt-bg-gray-100", onClick: openNewStageModal, children: [_jsx(PlusCircleIcon, { className: "wpqt-size-6 wpqt-text-green-600" }), _jsx("div", { className: "wpqt-whitespace-nowrap", children: __("Add first stage", "quicktasker") })] }) }));
    }
    return (_jsxs("div", { className: "wpqt-main-border wpqt-mb-3 wpqt-flex wpqt-cursor-pointer wpqt-flex-col wpqt-items-center wpqt-justify-start wpqt-self-start wpqt-p-3 hover:wpqt-bg-gray-100", onClick: openNewStageModal, children: [_jsx(PlusCircleIcon, { className: "wpqt-size-6 wpqt-text-green-600" }), _jsx("div", { className: "wpqt-whitespace-nowrap", children: __("Add stage", "quicktasker") })] }));
}
export { AddStage };
